import { InfoCircleOutlined } from "@ant-design/icons";
import { useTranslate } from "@refinedev/core";
import { Button, Result, Space, Tooltip, Typography } from "antd";
import React from "react";

const { Text } = Typography;

interface ErrorPageProps {
  error?: Error;
}
export const InternalErrorPage: React.FC<ErrorPageProps> = ({ error }) => {
  const translate = useTranslate();

  if (error?.message.includes("Failed to fetch dynamically imported module")) {
    console.error(error);
    window.location.reload();
    return null;
  }

  return (
    <Result
      extra={
        <Space direction="vertical" size="large">
          <Space>
            <Text>{translate("pages.error.500", "Sorry, something went wrong.")}</Text>
            {error && (
              <Tooltip title={error.message}>
                <InfoCircleOutlined data-testid="error-component-tooltip" />
              </Tooltip>
            )}
          </Space>
          <Button
            onClick={() => {
              window.location.reload();
            }}
            type="primary"
          >
            {translate("pages.error.refresh", "Refresh")}
          </Button>
        </Space>
      }
      status="500"
      title="500"
    />
  );
};
